
export function setCookieData(key: string, value: object, days = 1) {
  const json = JSON.stringify(value);
  const encoded = encodeURIComponent(json);
  const expiresDate = new Date(Date.now() + days * 864e5).toUTCString();

  document.cookie = [
    `${key}=${encoded}`,
    `expires=${expiresDate}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

export function getCookieData(key: string) {
  const cookieMap = document.cookie
    .split('; ')
    .map(pair => pair.split('='))
    .reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {});

  if (!(key in cookieMap)) return null;

  try {
    const decoded = decodeURIComponent(cookieMap[key]);
    return JSON.parse(decoded);
  } catch (err) {
    console.error(`Error parsing cookie "${key}":`, err);
    return null;
  }
}

export function getCookie(key: string) {
  const cookieMap = document.cookie
    .split('; ')
    .map(pair => pair.split('='))
    .reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {});

  if (!(key in cookieMap)) return null;

  try {
    const decoded = decodeURIComponent(cookieMap[key]);
    return decoded;
  } catch (err) {
    console.error(`Error parsing cookie "${key}":`, err);
    return null;
  }
}

export function setCookie(key: string, value: string, days = 1) {
  const expiresDate = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = [
    `${key}=${value}`,
    `expires=${expiresDate}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

// delete cookie
export function deleteCookie(key: string) {
  document.cookie = `${key}=; Max-Age=0; path=/; SameSite=Lax`;
}
